<template>
    <div class="employer-contact container">
        <div class="row">
            <amf-input v-if="isNew" label="Code" v-model="code" :columns="6" />
            <div v-else class="col-12"><h5>{{ code }}</h5></div>
        </div>
        <div class="row">
            <amf-checkbox v-model="active" label="Active" :columns="2" />
        </div>
        <div class="row">
            <amf-checkbox v-model="frequentlyUsed" label="Frequently Used" :columns="3" />
        </div>
        <div class="row">
            <amf-multiple-select :options="planTypes" v-model="selectedPlanTypes" label="Plans" :columns="12"/>
        </div>
        <div class="row">
            <amf-textarea label="Description" v-model="description" :columns="12" />
        </div>
        <div class="row">
            <amf-textarea label="Participant Portal" v-model="pPortal" :columns="12" />
            <amf-textarea label="IVR" v-model="ivr" :columns="12" />
            <amf-textarea label="Chat" v-model="chat" :columns="12" />
        </div>
    </div>
</template>

<script>
    import { utils } from '../framework'
    export default {
        props: {
            isNew: { type: Boolean, default: false },
            rejectionCode: { type: Object, default: null }
        },
        data() {
            return {
                amfOptions: { layout: "twelve-column"},
                planTypes: ['FSA', 'DCA', 'HRA', 'HSA', 'LPF', 'TRN', 'PKG'],
                selectedPlanTypes: [],
                code: null,
                description: null,
                alwaysShowNoteInClaim: false,
                chat: null,
                ivr: null,
                pPortal: null,
                plans: null,
                active: false,
                frequentlyUsed: false
            }
        },
        computed: {
            title() {
                return this.isNew ? 'New Rejection Code' : `Rejection Code ${this.code}`
            },
            buttons()  {
                return 'Save/Cancel';
            }
        },
        created() {
            if(this.isNew)
                this.active = true;
            
            if(this.rejectionCode) 
                utils.copyCommonProperties(this.rejectionCode, this.$data);

            if(this.plans)
                this.selectedPlanTypes = this.plans.split(',');
        },
        methods: {
            async save() {
                var route = 'claim-rejection-code';
                if(!this.isNew) route = `${route}/${this.rejectionCode.id}`;
                
                this.plans = this.selectedPlanTypes.join(',');
                await romeApi.post(route, this.$data);
                return this.$data;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/framework/ClaimRejectionCodeEditor.vue